export default {
  inserted(el) {
    // Initial scroll
    scrollToTop();

    // Handle dynamic content
    const observer = new MutationObserver(scrollToTop);
    observer.observe(el, {
      childList: true,
      subtree: true
    });

    function scrollToTop() {
      requestAnimationFrame(() => {
        window.scrollTo({
          top: 0,
          behavior: 'instant'
        });
      });
    }

    // Cleanup
    el._observer = observer;
  },
  
  unbind(el) {
    if (el._observer) {
      el._observer.disconnect();
    }
  }
}